import dynamic from 'next/dynamic';
import { RateCardProps } from './RateCard.types';

export const RateCard = dynamic<RateCardProps>(() => import('./RateCard').then(module => module.RateCard));
